import Vue from 'vue';
import VueI18n from 'vue-i18n';
import VueMoment from 'vue-moment';
require('moment/locale/de');
import { messages } from './messages';

Vue.use(VueI18n);
Vue.use(VueMoment);

class CustomI18nFormatter {
    interpolate(message, values) {
        if (values) {
            values = this.convertValues(values);

            for (var key in values) {
                message = message.replace('%{' + key + '}', values[key]);
            }
        }

        return [message];
    }
    convertValues(values, output, parent) {
        output = output || {};

        if (values) {
            for (var key in values) {
                if (typeof values[key] === 'object') {
                    output = this.convertValues(values[key], output, key)
                } else {
                    if (parent) {
                        output[parent + '.' + key] = values[key];
                    } else {
                        output[key] = values[key];
                    }
                }
            }
        }

        return output;
    }
}

export default new VueI18n({
    locale: 'de',
    fallbackLocale: 'en',
    messages: messages,
    formatter: new CustomI18nFormatter()
});
